import { Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';

interface Props {
  onClose: () => void;
  onCancel: () => void;
}

const ConfirmInviteExitModal = ({ onClose, onCancel }: Props) => {
  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      width="448px"
      closeButtonProps={{ hidden: true }}
    >
      <Flex flexDirection="column" gap={6} padding={8}>
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          style={{ width: '40px', height: '40px' }}
          color="actionSecondaryCautionContent"
        />

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Exit Without Finishing?</Text>
          <Text textStyle="textBody">
            You are about to leave this page. Are you sure you want to continue?
          </Text>
        </Flex>

        <Flex justifyContent="flex-end" gap={2}>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="caution" onClick={onClose}>
            Close
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ConfirmInviteExitModal;
